import { Link } from "react-router-dom";

function FooterLink({ to, children }) {
  return (
    <Link
      to={to}
      className="text-[0.82rem] text-text-muted hover:text-text-primary transition-colors no-underline"
    >
      {children}
    </Link>
  );
}

export default function PublicFooter() {
  return (
    <footer className="border-t border-white/[0.06] px-6 sm:px-10 py-12 sm:py-10">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-start gap-10 sm:gap-0 sm:justify-between">

        {/* Column 1 — Brand */}
        <div className="flex flex-col gap-3">
          <span className="font-display text-sm tracking-[0.25em] uppercase text-brand-gold">
            Band OS
          </span>
          <p className="text-text-muted text-[0.8rem] leading-relaxed max-w-[220px]">
            The performance system gigging bands run on.
          </p>
        </div>

        {/* Column 2 — Product links */}
        <div className="flex flex-col gap-3">
          <span className="text-[0.65rem] uppercase tracking-[0.15em] text-text-muted font-sans">
            Product
          </span>
          <nav className="flex flex-col gap-2">
            <FooterLink to="/pricing">Pricing</FooterLink>
            <FooterLink to="/login">Sign in</FooterLink>
            <FooterLink to="/signup">
              Get started free
            </FooterLink>
          </nav>
        </div>

        {/* Column 3 — Legal + Support */}
        <div className="flex flex-col gap-3">
          <span className="text-[0.65rem] uppercase tracking-[0.15em] text-text-muted font-sans">
            Legal & support
          </span>
          <nav className="flex flex-col gap-2">
            <FooterLink to="/privacy">Privacy Policy</FooterLink>
            <FooterLink to="/terms">Terms of Service</FooterLink>
            <a
              href="mailto:hi@bandos.app"
              className="text-[0.82rem] text-text-muted hover:text-text-primary transition-colors"
            >
              hi@bandos.app
            </a>
          </nav>
        </div>

      </div>

      {/* Bottom bar */}
      <div className="max-w-5xl mx-auto mt-10 pt-6 border-t border-white/[0.04] flex flex-col sm:flex-row items-center justify-between gap-2">
        <span className="text-[0.72rem] text-text-muted">
          © {new Date().getFullYear()} Band OS. All rights reserved.
        </span>
        <span className="text-[0.72rem] text-text-muted">
          Built for working musicians.
        </span>
      </div>
    </footer>
  );
}
